import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SetDefaultPaymentMethodMutation = graphql.persisted(
  "SetDefaultPaymentMethod",
  graphql(`
    mutation SetDefaultPaymentMethod($familyEnrollmentId: ID!, $paymentMethodId: ID!) {
      setDefaultPaymentMethod(input: { familyEnrollmentId: $familyEnrollmentId, paymentMethodId: $paymentMethodId }) {
        paymentMethodSummary
        userErrors { message path }
      }
    }
  `)
);

export { SetDefaultPaymentMethodMutation };

export function useSetDefaultPaymentMethod() {
  return useMutation(SetDefaultPaymentMethodMutation);
}
